import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { BreakpointMatcherService } from 'src/app/core/services/breakpoint-matcher.service';
import { SessionService } from 'src/app/core/services/session.service';
import { BreakpointState } from '@angular/cdk/layout';
import { IGroup } from 'src/app/core/models/Group';
import { GroupType, Language } from 'src/app/core/enums/enums';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-migration-notice',
  templateUrl: './migration-notice.component.html',
  styleUrls: ['./migration-notice.component.scss'],
})
export class MigrationNoticeComponent implements OnInit {
  articleLink?: string;
  migrationDate = '06/08/2025';
  blocageDate = '24/07/2025';
  breackpointMatche = false;
  currentGroup: IGroup;
  GroupType = GroupType;
  qrcodeImg = 'assets/images/qrcode-en.png';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      articleLink?: string;
      migrationDate?: string;
      blocageDate?: string;
      caller: string;
    },
    public dialogRef: MatDialogRef<MigrationNoticeComponent>,
    private sessionService: SessionService,
    private breakpointMatcherService: BreakpointMatcherService,
    private translateService: TranslateService
  ) {
    if (data) {
      this.articleLink = this.data.articleLink ?? undefined;
      this.blocageDate = this.data.blocageDate ?? this.blocageDate;
      this.migrationDate = this.data.migrationDate ?? this.migrationDate;
    }
    this.currentGroup = this.sessionService.getCurrentRole()?.group;
    this.qrcodeImg =
      this.translateService.currentLang === Language.EN
        ? 'assets/images/qrcode-en.png'
        : 'assets/images/qrcode-fr.png';
  }

  ngOnInit() {
    this.breakpointMatcherService
      .initObserver('md')
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.breackpointMatche = true;
        } else {
          this.breackpointMatche = false;
        }
      });
  }

  close() {
    this.sessionService.storeMigrationNoticeSeen();
    this.dialogRef.close();
  }
}
